import { useCallback } from "react";
import type { AppbarActionProps } from "react-native-paper";
import { Appbar } from "react-native-paper";
import type { IconType } from "../icon";
import { AppIcon } from "./AppIcon";

type Props = AppbarActionProps & {
	icon: IconType;
};

const AppbarAction = (props: Props) => {
	const { icon, ...rest } = props;
	const renderIcon = useCallback(
		(iconProps: { size: number; color: string }) => (
			<AppIcon name={icon} {...iconProps} />
		),
		[icon],
	);
	return <Appbar.Action {...rest} icon={renderIcon} />;
};

export default AppbarAction;
